import { render, staticRenderFns } from "./changeDomain.vue.js?vue&type=template&id=dfa2c35c&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeDomain.vue?vue&type=template&id=dfa2c35c&scoped=true"
import script from "./changeDomain.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeDomain.vue?vue&type=script&lang=js"
export * from "./changeDomain.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeDomain.vue?vue&type=script&lang=js"
import style0 from "./changeDomain.vue.scss?vue&type=style&index=0&id=dfa2c35c&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeDomain.vue?vue&type=style&index=0&id=dfa2c35c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa2c35c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfa2c35c')) {
      api.createRecord('dfa2c35c', component.options)
    } else {
      api.reload('dfa2c35c', component.options)
    }
    module.hot.accept("./changeDomain.vue.js?vue&type=template&id=dfa2c35c&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeDomain.vue?vue&type=template&id=dfa2c35c&scoped=true", function () {
      api.rerender('dfa2c35c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/Dialog/changeDomain.vue"
export default component.exports